/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import ColonyCass from 'solis/logic/board/colony/cass';
import ZoneControl from 'solis/logic/board/zone/control';
import ZoneInfluences from 'solis/logic/board/zone/influences';
import ZoneUsers from 'solis/logic/board/zone/users';

import BoardUser from 'solis/claude/logic/board/user';


const BANDS = [ 0.1, 0.3, 0.45, 0.6, 0.75, 0.9 ];


export default class extends Logic
{
  constructor (zone, parent)
  {
    super(zone);

    this.parent = parent;

    this.hex = zone.getAbsoluteHex();
  }


  getNeighbor (index)
  {
    const hex = this.hex.getNeighborsInOrder()[index];

    return this.parent.getZone(hex);
  }


  getNeighbors ()
  {
    return this.hex.getNeighborsInOrder().map(hex => this.parent.getZone(hex));
  }


  isExternalBorder (neighbor)
  {
    return neighbor == null || !neighbor.#getFutureColony().equals(this.#getFutureColony());
  }


  isTemporaryBorder (neighbor)
  {
    return !new ColonyCass(this.#getFutureColony()).hasCoreSector();
  }


  isGroupBorder (neighbor)
  {
    return neighbor != null && neighbor.cass.sector !== this.cass.sector;
  }


  isJaggedBorder (neighbor)
  {
    if (this.isExternalBorder(neighbor))
    {
      return false;
    }

    const users = ZoneUsers.of(this);
    const others = ZoneUsers.of(neighbor);

    return users.isSectorOccupied() && !users.isCurrentUser(others.getCurrentUser()) && (!others.isSectorOccupied() || users.getCurrentUser() < others.getCurrentUser());
  }


  #getFutureColony ()
  {
    return this.object.getSector().getFutureColony();
  }


  isEmphasized ()
  {
    return false;
  }


  isDimmed ()
  {
    return false;
  }


  getBeaconValue ()
  {
    return new ZoneInfluences(this.object).getChallengerInfluences().length;
  }


  isEstablished ()
  {
    return new ZoneUsers(this.object).getEstablishedUsers().length > 0;
  }


  getBackgroundBand (now)
  {
    const ratio = new ZoneControl(this.object).getChallengerRatio(now);

    return BANDS.filter(threshold => ratio >= threshold).length;
  }


  getDisplayHex ()
  {
    return this.hex;
  }


  getEntityHex ()
  {
    return this.hex;
  }


  getColor ()
  {
    return new BoardUser(this.object.getBoard(), this.cass.currentUser).getColor();
  }


  equals (other)
  {
    return super.equals(other) && this.parent.equals(other.parent);
  }


};
